import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/map'
import 'echarts/lib/chart/radar'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/chart/effectScatter'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/polar'
import 'echarts/lib/component/geo'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/component/visualMap'
import 'echarts/lib/component/dataset'
import 'echarts/lib/component/toolbox'
import 'echarts-wordcloud'
import chinaMap from '../map/china'
import beijingMap from '../map/province/beijing'
import shanghaiMap from '../map/province/shanghai'
import theme from './echarts_theme'

ECharts.registerMap('china', chinaMap)
ECharts.registerMap('province/beijing', beijingMap)
ECharts.registerMap('province/shanghai', shanghaiMap)
ECharts.registerTheme('dark', theme)

export default ECharts
